<template>
  <core-main ref="main" class="px-8 py-12">
    <template v-slot:toolbar-title>
      <v-btn
        icon
        @click="goToRfq"
      >
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
      {{ isNewEstimate ? $t('form.rfq.newName') : `Estimate ${currentRfq && currentRfq.csiRfqId || tempRfqId}` }}
    </template>

    <template v-slot:toolbar-icons>
      <v-btn
        slot="activator"
        icon
        @click="cardView = !cardView"
      >
        <v-icon>{{ getDisplayIcon }}</v-icon>
      </v-btn>
    </template>

    <v-container>
      <v-row>
        <v-col style="position: relative;">
          <v-btn
            absolute
            fab
            icon
            style="position: aboslute; top: 50%; transform: translate(0, -50%)"
            @click="openDropzoneDialog"
          >
            <v-icon x-large>
              mdi-plus-circle
            </v-icon>
          </v-btn>

          <vue-dropzone
            id="dropzone"
            ref="dropzone"
            :options="dropzoneOptions"
            :include-styling="false"
            :use-custom-slot="true"
          >
            <div class="dropzone-custom-content">
              <h3 class="dropzone-custom-title">
                Drag and drop to upload content!
              </h3>
              <div class="subtitle">
                ...or click to select a file from your computer
              </div>
            </div>
          </vue-dropzone>
        </v-col>
      </v-row>

      <!-- Cardview section -->
      <v-row v-if="cardView">
        <v-col
          v-for="(part, index) in parts"
          :key="index"
          cols="12"
        >
          <!-- Depends if record is temporary -->
          <core-upload-part-card
            :ref="`uploadPartCard${part._id}`"
            :key="`part-${index}`"
            :part="part"
            :materials="rootMaterials"
            @thumbnail:clicked="onOpenDetail($event)"
            @calculatecost="savePart"
          />
        </v-col>
      </v-row>
      <!-- Listview section -->
      <v-row
        v-else
        justify="center"
      >
        <v-col cols="auto">
          <core-upload-part-spread-sheet v-model="parts" />
        </v-col>
      </v-row>
    </v-container>

    <v-col md="2">
      <v-btn
        :disabled="!arePartsReadyForSubmission"
        class="white--text"
        fixed
        bottom
        right
        rounded
        style="top: 90%; z-index: 1;"
        color="green"
        @click="submitRfq"
      >
        {{ submitBtnText }}
      </v-btn>
    </v-col>

    <!-- Pixel values of toolbar + side menu -->
    <v-navigation-drawer
      v-model="isPartViewerActive"
      style="margin-top: 0px;
        width: 100%;
        background-color: rgba(33, 33, 33, .46);"
      fixed
      stateless
      hide-overlay
      right
      temporary
    >
      <div style="position: relative; margin-top: 87px;">
        <!--        <div style="position: absolute; z-index: 99; bottom: 10px; left: 10px;">-->
        <!--          <v-card>-->
        <!--            <v-card-title-->
        <!--              class="py-1"-->
        <!--              style="background-color: #4fb052; color: white;"-->
        <!--            >-->
        <!--              {{ _.get(_.first(analysisData), 'value') }}-->
        <!--            </v-card-title>-->

        <!--            <v-simple-table dense>-->
        <!--              <template v-slot:default>-->
        <!--                <tbody>-->
        <!--                  <tr-->
        <!--                    v-for="item in analysisData.slice(1)"-->
        <!--                    :key="item.field"-->
        <!--                  >-->
        <!--                    <td>-->
        <!--                      {{ item.field }}-->
        <!--                    </td>-->
        <!--                    <td>-->
        <!--                      {{ item.value }}-->
        <!--                    </td>-->
        <!--                  </tr>-->
        <!--                </tbody>-->
        <!--              </template>-->
        <!--            </v-simple-table>-->
        <!--          </v-card>-->
        <!--        </div>-->

        <div style="position: absolute; z-index: 99; bottom: 10px; right: 10px;">
          <v-card style="margin-bottom: 10px;">
            <v-card-title
              class="py-1"
              style="background-color: #4fb052; color: white;"
            >
              {{ _.get(_.first(partDesignData), 'value') }}
            </v-card-title>

            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr
                    v-for="(item, i) in partDesignData.slice(1)"
                    :key="item.field"
                    :class="{'dark': (i % 2 !== 0)}"
                  >
                    <td>
                      <v-icon color="primary">
                        {{ item.icon }}
                      </v-icon>
                      <!--                      <v-icon>mdi-heart</v-icon>-->
                      {{ item.field }}
                    </td>
                    <td>
                      {{ item.value }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>

          <v-card>
            <v-card-title
              class="py-1"
              style="background-color: #4fb052; color: white;"
            >
              {{ _.get(_.first(analysisData), 'value') }}
            </v-card-title>

            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr
                    v-for="(item, i) in analysisData.slice(1)"
                    :key="item.field"
                    :class="{'dark': (i % 2 !== 0)}"
                  >
                    <td>
                      <v-icon
                        :color="item.color
                          ? item.color
                          : item.value === 'Pass'
                            ? 'primary'
                            : 'error'"
                      >
                        {{ item.icon }}
                      </v-icon>
                      {{ item.field }}
                    </td>
                    <td>
                      {{ item.value }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </div>

        <!--        style="position: relative; top: 87px;"-->
        <div class="d-flex justify-end mx-2">
          <v-btn
            color="orange"
            block
            @click="isPartViewerActive = false; cleanUpThreeJs();"
          >
            <v-icon left>
              mdi-close
            </v-icon>
            Close 3D Inspector
          </v-btn>
        </div>

        <div class="d-flex justify-center" style="width: 100%;">
          <div id="3dview" style="width: 100%;" />
        </div>
      </div>
    </v-navigation-drawer>

    <v-dialog
      v-model="isRfqSaving"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-text>
          <v-list dense>
            <v-list-item v-for="(p, i) in parts" :key="i" dense>
              <v-list-item-content>
                {{ p.CustItemName }}
              </v-list-item-content>
              <v-list-item-action-text>
                <span v-if="p.EstimateLineStatus.isNestingCalculated">
                  Ok
                </span>
                <span v-else-if="p.EstimateLineStatus.isCalculatingNesting">
                  Analyzing
                </span>
                <span v-else>
                  Queued
                </span>
              </v-list-item-action-text>
              <v-list-item-action>
                <v-icon
                  v-if="p.EstimateLineStatus.isNestingCalculated"
                  color="primary"
                >
                  mdi-check
                </v-icon>
                <v-progress-circular
                  v-else-if="p.EstimateLineStatus.isCalculatingNesting"
                  indeterminate
                  size="18"
                  width="2"
                />
                <v-icon
                  v-else
                >
                  mdi-tent
                </v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <!--        <v-card-actions>-->
        <!--          <v-btn @click="isRfqSaving = false;">-->
        <!--            close-->
        <!--          </v-btn>-->
        <!--        </v-card-actions>-->
      </v-card>
    </v-dialog>
  </core-main>
</template>

<script>

import { mapGetters, mapState } from 'vuex';
import vueDropzone from 'vue2-dropzone';
import { v4 as uuidv4 } from 'uuid';
import * as THREE from 'three';
import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls';
import { OBJLoader2 } from 'three/examples/jsm/loaders/OBJLoader2';
import { models } from 'feathers-vuex';
import AuthMixin from '../../mixins/auth';

const {
  Rfq, TempRfq, TempPart, Material, Finish,
} = models.api;

// Consts
// The scene should be a const to be able to reach it inside a callback function
let scene = null; // new THREE.Scene();

export default {
  mixins: [
    AuthMixin,
  ],

  components: {
    vueDropzone,
  },

  data() {
    return {
      cardView: true,
      submitBtnText: 'Submit RFQ',
      fullScreen: false,
      width3d: 500,
      height3d: 300,
      cameraTarget: null,
      isPartViewerActive: false,
      partViewerPart: null,
      tempRfq: null,
      isRfqSaving: false,
    };
  },

  computed: {
    // TODO use new fancy static methods (https://vuex.feathersjs.com/model-classes.html#extending-the-basemodel-class)
    ...mapState('auth', ['accessToken']),
    ...mapState('materials', { materialsStateIds: 'ids' }),
    ...mapGetters('finishes', { findFinishes: 'find' }),

    analysisData() {
      let tableData = [];

      const analysisData = _.get(this.partViewerPart, 'CsiAnalysisData', []);

      if (_.isEmpty(analysisData)) {
        tableData = [
          { field: null, value: 'Manufacturability & Design' },
          { field: 'Unfolding', value: '-' },
          { field: 'Bend to Hold', value: '-' },
          { field: 'Hole to Edge', value: '-' },
          { field: 'Bend Radius', value: '-' },
          { field: 'Bend to Edge', value: '-' },
          { field: 'Hole Size vs Thickness', value: '-' },
        ];
      } else {
        tableData = analysisData.filter((datum) => datum.Category === 'T1')
          .sort((datum1, datum2) => +datum1.Rank - +datum2.Rank)
          .map((datum) => ({ field: datum.Description, value: datum.Value }));
      }

      const message = _.get(this.partViewerPart, 'EstimateLineStatus.isManufacturableMsg', '-');
      const isManufacturable = _.get(this.partViewerPart, 'EstimateLineStatus.isManufacturable');
      tableData.push({
        field: 'Warnings', value: (isManufacturable ? message : '-'), /* icon: 'mdi-heart', */ color: 'error',
      });
      tableData.push({
        field: 'Errors', value: (isManufacturable ? '-' : message), /* icon: 'mdi-clock', */ color: 'grey',
      });

      const icons = { Pass: 'mdi-check', Fail: 'mdi-close' };
      return tableData.map((row) => ({ ...{ icon: _.get(icons, row.value, 'mdi-close') }, ...row }));
    },

    partDesignData() {
      let tableData = [];

      const analysisData = _.get(this.partViewerPart, 'CsiAnalysisData', []);

      if (_.isEmpty(analysisData)) {
        tableData = [
          { field: null, value: 'Parts Design Data' },
          { field: 'Net Weight (kg)', value: '-' },
          { field: 'Gross Weight (kg)', value: '-' },
          { field: 'Material usage (%)', value: '-' },
          { field: '# of Fabrication Processes', value: '-' },
          { field: 'Quantity / sheet', value: '-' },
          { field: 'Material', value: '-' },
        ];
      } else {
        tableData = analysisData.filter((datum) => datum.Category === 'T2')
          .sort((datum1, datum2) => +datum1.Rank - +datum2.Rank)
          .map((datum) => ({ field: datum.Description, value: datum.Value }));
      }

      const icons = [
        'mdi-weight',
        'mdi-weight',
        'mdi-lightning-bolt-outline',
        'mdi-cog-outline',
        'mdi-scale',
        'mdi-square-circle',
      ];
      return tableData.map((row, index) => ({ ...{ icon: icons[index - 1] }, ...row }));
    },

    tempRfqId() {
      return this.$route.params.id;
    },

    currentRfq() {
      if (this.isNewEstimate && !this.tempRfq) {
        return null;
      }
      if (this.tempRfq) {
        return this.tempRfq;
      }
      return TempRfq.getFromStore(this.tempRfqId);
    },

    isNewEstimate() {
      return this.tempRfqId === 'new';
    },

    parts() {
      if (this.isNewEstimate) {
        return [];
      }

      return TempPart.findInStore({
        temps: true,
        query: {
          tempRfqId: this.tempRfqId,
        },
      }).data;
    },

    rootMaterials() {
      return Material.findInStore({
        query: {
          ParentRowPointer: null,
          IsHidden: false,
        },
      }).data;
    },

    uploadHeaders() {
      return {
        Service: 'rfqs',
      };
    },

    dropzoneOptions() {
      const h = process.env.VUE_APP_API_URL || 'http://localhost:3031/';
      const vm = this;

      return {
        url: `${h}upload`,
        paramName: 'file',
        headers: {
          Authorization: this.accessToken,
        },
        thumbnailWidth: 150,
        maxFilesize: 5,
        dictDefaultMessage: 'Drag and drop drawings on the screen or click to browse files',
        previewTemplate: this.template(),
        acceptedFiles: '.IGS,.SLDDRW,.STEP,.SLDPRT,.STP,.IGES',
        renameFile: (file) => `${vm.getNewUuid()}.${_.last(file.name.split('.'))}`,
        init() {
          this.on('addedfile', async (file) => {
            const partData = {
              ReqQty: 1,
              // Strip extension
              CustItemName: file.name.replace(/\.[^/.]+$/, ''),
              DrawingRowPointer: file.upload.filename.split('.')[0],
              uniqueFileName: file.upload.filename,
              uploadProgress: 0,
            };
            if (vm.currentRfq && vm.currentRfq._id) {
              partData.tempRfqId = vm.currentRfq._id;
            }

            // eslint-disable-next-line no-unused-vars
            const part = new TempPart(partData);

            if (!vm.currentRfq) {
              vm.tempRfq = new TempRfq({});
              const rfq = await vm.tempRfq.save();
              vm.tempRfq = null;

              vm.$router.replace(`/rfqs/${rfq._id}`);

              const parts = TempPart.findInStore({
                temps: true,
                query: {
                  uploadProgress: 100,
                },
              });

              Promise.all(parts.data.map(async (p) => {
                p.tempRfqId = rfq._id;
                return p.save();
              }));
            }
          });

          this.on('uploadprogress', (file, progress) => {
            const parts = TempPart.findInStore({
              temps: true,
              query: {
                uniqueFileName: file.upload.filename,
              },
            });
            const part = _.first(parts.data);
            part.uploadProgress = progress;
          });

          this.on('success', async (file, response) => {
            // eslint-disable-next-line no-underscore-dangle
            if (!vm.currentRfq || vm.currentRfq.__isTemp) {
              return;
            }

            const parts = TempPart.findInStore({
              temps: true,
              query: {
                uniqueFileName: file.upload.filename,
              },
            });
            const part = _.first(parts.data);
            part.tempRfqId = vm.currentRfq._id;

            await part.save();

            vm.$refs.dropzone.removeFile(file);
          });
        },
      };
    },

    getDisplayIcon() {
      return this.cardView ? 'mdi-format-list-bulleted' : 'mdi-view-grid';
    },

    arePartsReadyForSubmission() {
      if (_.isEmpty(this.parts)) {
        return false;
      }
      /* Can't find a part that is NOT ready for submission */
      return !this.parts.find((part) => !this.isPartReadyForSubmission(part));
    },

    isRfqReadyForSubmission() {
      if (_.isEmpty(this.parts)) {
        return false;
      }
      return this.isRfqSaving
        && this.parts.filter((part) => !part.EstimateLineStatus.isNestingCalculated
          || !part.EstimateLineStatus.isCuttingCalculated).length === 0;
      // this.arePartsReadyForSubmission;
      // && !this.parts.find((part) => !part.EstimateLineStatus.isNestingCalculated);
    },
  },

  watch: {
    async isRfqReadyForSubmission(val, oldVal) {
      if (val && !oldVal) {
        try {
          await this.currentRfq.save({
            data: {
              shouldSubmitRfq: true,
              csiRfqId: this.currentRfq.csiRfqId,
            },
          });

          await Rfq.get(this.currentRfq.csiRfqId);

          this.$router.push({ path: '/rfqs' });
        } catch (e) {
          this.isRfqSaving = false;
        }
      }
    },

    $route: {
      immediate: true,
      async handler(to) {
        if (to.name !== 'EditRFQ' || this.tempRfqId === 'new') {
          return;
        }

        try {
          await TempRfq.get(this.tempRfqId);
          await TempPart.find({
            query: {
              tempRfqId: this.tempRfqId,
            },
          });
        } catch (error) {
          this.$router.replace('/rfqs/new');
        }
      },
    },
  },

  mounted() {
    this.autoLoadMaterials();
    Finish.find({ query: {} });
  },

  created() {
    window.addEventListener('resize', this.onResize);
  },

  destroyed() {
    window.removeEventListener('resize', this.onResize);
    // Removing all children...
    for (let i = scene.children.length - 1; i >= 0; i--) {
      scene.remove(scene.children[i]);
    }

    let myNode = document.getElementById('3dview');
    if (myNode) {
      while (myNode.firstChild) {
        myNode.removeChild(myNode.firstChild);
      }
    }
    myNode = document.getElementById('FullScreen3dView');
    if (myNode) {
      while (myNode.firstChild) {
        myNode.removeChild(myNode.firstChild);
      }
    }
    this.animate = null;
    this.camera = null;
    this.renderer = null;
    this.controls = null;
  },

  methods: {
    isPartReadyForSubmission(part) {
      const { EstimateLineStatus } = part;

      /* Currently calculating */
      if (EstimateLineStatus.isCalculatingCutting || EstimateLineStatus.isCalculatingNesting) {
        return false;
      }
      /* No finish selected */
      if (!part.MaterialFinish) {
        return false;
      }
      /* Finish selected, but sub-options available and not selected */
      if (_.isEmpty(part.MaterialFinishOption) && !_.isEmpty(this.getPartOptions(part))) {
        return false;
      }
      return true;
    },

    getPartOptions(part) {
      return part.MaterialThickness && part.MaterialFinish ? this.findFinishes({
        query: {
          ParentRowPointer: part.MaterialFinish,
          IsHidden: false,
        },
      }).data : [];
    },

    async savePart(part) {
      part.EstimateLineStatus.isNestingCalculated = false;
      part.EstimateLineStatus.isCalculatingNesting = true;
      part.EstimateLineStatus.isCuttingCalculated = false;
      part.EstimateLineStatus.isCalculatingCutting = true;

      /* Remove call to CSI for now */
      if (!this.currentRfq.isCsi) {
        await this.currentRfq.save({
          data: {
            isCsi: true,
          },
        });
      }

      part.csiRfqId = this.currentRfq.csiRfqId;

      await part.save();
    },

    async submitRfq() {
      this.isRfqSaving = true;

      if (!this.currentRfq.isCsi) {
        await this.currentRfq.save({
          data: {
            isCsi: true,
          },
        });
      }

      /* TODO error handling */
      /* Deviation: Not using forEach on purpose,
      * we WANT to do it in sequence for dramatic effect */
      for (const p of this.parts) {
        if (p.EstimateLineStatus.isCuttingCalculated && p.EstimateLineStatus.isNestingCalculated) {
          continue;
        }
        await this.savePart(p);
      }
    },

    openDropzoneDialog() {
      this.$refs.dropzone.dropzone.clickableElements[0].click();
    },

    autoLoadMaterials() {
      // load material cache for current session if empty
      if (!this.materialsStateIds.length) {
        Material.find({
          query: {
            IsHidden: false,
          },
        });
      }
    },

    getNewUuid() {
      return uuidv4();
    },

    // https://rowanwins.github.io/vue-dropzone/docs/dist/#/custom-preview
    template() {
      return `<div class="dz-preview dz-file-preview" style="display: none;">
                <div class="dz-details">
                  <div class="dz-filename"><span data-dz-name></span></div>
                  <div class="dz-size" data-dz-size></div>
                  <img data-dz-thumbnail />
                </div>
                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                <div class="dz-success-mark"><span></span></div>
                <div class="dz-error-mark"><span></span></div>
                <div class="dz-error-message"><span data-dz-errormessage></span></div>
              </div>
        `;
    },

    goToRfq() {
      this.$router.push({ path: '/rfqs' });
    },

    fitCameraToObject(camera, object, offset, controls) {
      offset = offset || 1.25;

      const boundingBox = new THREE.Box3();

      // get bounding box of object - this will be used to setup controls and camera
      boundingBox.setFromObject(object);

      const center = boundingBox.getCenter(new THREE.Vector3());

      const size = boundingBox.getSize(new THREE.Vector3());

      // get the max side of the bounding box (fits to width OR height as needed )
      const maxDim = Math.max(size.x, size.y, size.z);
      const fov = camera.fov * (Math.PI / 180);
      // eslint-disable-next-line no-mixed-operators
      let cameraZ = Math.abs(maxDim / 4 * Math.tan(fov * 2));

      cameraZ *= offset; // zoom out a little so that objects don't fill the screen

      camera.position.z = cameraZ;

      const minZ = boundingBox.min.z;
      const cameraToFarEdge = (minZ < 0) ? -minZ + cameraZ : cameraZ - minZ;

      camera.far = cameraToFarEdge * 3;
      camera.updateProjectionMatrix();

      if (controls) {
        // set camera to rotate around center of loaded object
        controls.target = center;

        // prevent camera from zooming out far enough to create far plane cutoff
        controls.maxDistance = cameraToFarEdge * 2;

        controls.saveState();
      } else {
        camera.lookAt(center);
      }
    },

    cleanUpThreeJs() {
      window.removeEventListener('resize', this.onResize);
      // Removing all children...
      for (let i = scene.children.length - 1; i >= 0; i--) {
        scene.remove(scene.children[i]);
      }

      let myNode = document.getElementById('3dview');
      if (myNode) {
        while (myNode.firstChild) {
          myNode.removeChild(myNode.firstChild);
        }
      }
      myNode = document.getElementById('FullScreen3dView');
      if (myNode) {
        while (myNode.firstChild) {
          myNode.removeChild(myNode.firstChild);
        }
      }
      scene = null;
      // this.animate = null;
      this.camera = null;
      this.renderer = null;
      this.controls = null;
    },

    onOpenDetail(part) {
      scene = new THREE.Scene();
      this.init();

      this.isPartViewerActive = true;
      this.partViewerPart = part;
      const baseMaterial = new THREE.MeshPhongMaterial({ color: 0x777777 });

      // Removing all children...
      for (let i = scene.children.length - 1; i >= 0; i--) {
        if (
          scene.children[i].type === 'Mesh'
          || scene.children[i].type === 'LineSegments'
        ) {
          scene.remove(scene.children[i]);
        }
      }

      const host = process.env.VUE_APP_API_URL || 'http://localhost:3031/'; // or set a string here, directly

      // Add current
      this.loader.load(
        `${host}uploads/${part.DrawingRowPointer}.obj`,
        (mesh) => {
          mesh.scale.set(0.5, 0.5, 0.5);
          mesh.position.set(0, 0, 0);
          mesh.rotation.set(0, 0, 0);

          const box = new THREE.Box3().setFromObject(mesh);
          const center = box.getCenter(new THREE.Vector3());

          mesh.position.x = -center.x;
          mesh.position.y = -center.y;
          mesh.position.z = -center.z;

          mesh.traverse((child) => {
            if (child instanceof THREE.Mesh) {
              child.material = baseMaterial;
              child.material.side = THREE.DoubleSide;

              if (child.geometry !== undefined) {
                const edges = new THREE.EdgesGeometry(child.geometry);
                const line = new THREE.LineSegments(
                  edges,
                  new THREE.LineBasicMaterial({ color: 0x000000 }),
                );

                line.position.x = -center.x;
                line.position.y = -center.y;
                line.position.z = -center.z;

                line.scale.set(0.5, 0.5, 0.5);
                scene.add(line);
              }
            }
          });

          scene.add(mesh);
          this.fitCameraToObject(this.camera, mesh, 2.8);
        },
        undefined,
        (error) => {
          console.error(error);
        },
      );
    },

    onResize(e) {
      if (this.renderer) {
        this.width3d = window.innerWidth; // - 200;
        this.height3d = window.innerHeight - 130;
        // this.height3d = window.innerHeight - 36;
        this.camera.aspect = this.width3d / this.height3d;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.width3d, this.height3d);
      }
    },

    onFullScreen(full) {
      let dst = document.getElementById('3dview');
      let src = document.getElementById('FullScreen3dView');
      if (full) {
        dst = document.getElementById('FullScreen3dView');
        src = document.getElementById('3dview');
      }
      while (src.childNodes.length > 0) {
        dst.appendChild(src.childNodes[0]);
      }
      this.fullScreen = full;
      this.onResize();
    },

    addShadowedLight(x, y, z, color, intensity) {
      const directionalLight = new THREE.DirectionalLight(color, intensity);
      directionalLight.position.set(x, y, z);
      directionalLight.lookAt(0, 0, 0);
      this.camera.add(directionalLight);

      directionalLight.castShadow = true;

      const d = 1;
      directionalLight.shadow.camera.left = -d;
      directionalLight.shadow.camera.right = d;
      directionalLight.shadow.camera.top = d;
      directionalLight.shadow.camera.bottom = -d;

      directionalLight.shadow.camera.near = 1;
      directionalLight.shadow.camera.far = 4;

      directionalLight.shadow.mapSize.width = 1024;
      directionalLight.shadow.mapSize.height = 1024;

      directionalLight.shadow.bias = -0.002;
    },

    createLights() {
      if (this.camera) {
        // Lights
        this.camera.add(new THREE.HemisphereLight(0x443333, 0x111122));
        this.addShadowedLight(1, 1, 1, 0xffffff, 1.35);
      }
    },
    animate() {
      if (scene) {
        requestAnimationFrame(this.animate);
        this.controls.update();
        this.render();
      }
    },
    render() {
      if (this.renderer) {
        // https://threejs.org/examples/#webgl_geometry_cube
        // const timer = Date.now() * 0.0005;
        // this.camera.position.x = Math.cos(timer) * 100;
        // this.camera.position.z = Math.sin(timer) * 100;
        // this.camera.lookAt(this.cameraTarget);

        // this.camera.lookAt(0, 0, 0);
        this.renderer.render(scene, this.camera);
      }
    },
    init() {
      const VIEW_ANGLE = 35;
      const ASPECT = this.width3d / this.height3d;
      const NEAR = 0.1;
      const FAR = 20000;

      const container = document.getElementById('3dview');

      // Renderer
      this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      this.renderer.setClearColor(0x000000, 0); // the default
      this.renderer.setSize(this.width3d, this.height3d);
      container.appendChild(this.renderer.domElement);

      // Camera
      this.camera = new THREE.PerspectiveCamera(
        VIEW_ANGLE, // Field of view
        ASPECT, // Aspect ratio
        NEAR, // Near plane
        FAR, // Far plane
      );
      this.camera.position.set(
        -37.565773010253906,
        -25.910253524780273,
        -97.5260238647461,
      );
      this.camera.lookAt(0, 0, 0);
      scene.add(this.camera);
      // Lights
      this.createLights();

      // placeholder for the FreeCAD camera
      this.controls = new TrackballControls(this.camera, this.renderer.domElement);
      this.controls.rotateSpeed = 10;
      this.controls.zoomSpeed = 10;
      this.controls.noZoom = false;
      this.controls.noPan = true;
      this.controls.staticMoving = true;
      this.controls.dynamicDampingFactor = 0.3;
      this.controls.keys = [65, 83, 68];

      // Load OBJ files
      this.loader = new OBJLoader2();

      // Call render
      this.animate();
    },
  },
};
</script>

<style>
  #dropzone {
    background-color: #e3e3e3;
    font-family: 'Arial', sans-serif;
    letter-spacing: 0.2px;
    color: #777;
    transition: background-color .2s linear;
    height: 150px;
    padding: 40px;
    border: dashed;
  }

  .dz-clickable {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>

<style scoped>
  .cell {
    background-color: #e1dbdb;
    padding-left: 10px;
  }

  .dark {
    background-color: #fff;
  }
</style>
